
namespace RioERP.Inventory {

    @Serenity.Decorators.registerClass()
    export class BookInwardGrid extends Serenity.EntityGrid<BookInwardRow, any> {
        protected getColumnsKey() { return BookInwardColumns.columnsKey; }
        protected getDialogType() { return BookInwardDialog; }
        protected getIdProperty() { return BookInwardRow.idProperty; }
        protected getInsertPermission() { return BookInwardRow.insertPermission; }
        protected getLocalTextPrefix() { return BookInwardRow.localTextPrefix; }
        protected getService() { return BookInwardService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}